import React from 'react';
import JBSLogo from '../assets/logo.png';
import AgroLogo from '../assets/agroLogo.png';

const logos = [JBSLogo, AgroLogo, JBSLogo, AgroLogo, JBSLogo, AgroLogo];

const LogoTicker = () => {
  return (
    <div className="relative w-full overflow-hidden py-4">
      <div className="flex gap-12 animate-scroll min-w-[200%]">
        {[...logos, ...logos].map((logo, index) => (
          <img
            key={index}
            src={logo}
            alt={`logo-${index}`}
            className="h-16 sm:h-20 w-auto object-contain opacity-60 shrink-0"
          />
        ))}
      </div>
    </div>
  );
};

export default LogoTicker;
